import { Link } from "react-router";

import { AppHeader } from "@/components/app-header";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useHealth, useWikiMe } from "@/lib/api";

const CONNECTOR_URL = "https://boi-marketing-os.boardofinnovation.ai/mcp";

export function HomePage() {
  const { data: health } = useHealth();
  const { data: wikiMe } = useWikiMe();

  const backendStatus = health?.status ?? "unreachable";
  const pending = wikiMe?.pending_approvals ?? 0;

  return (
    <div className="bg-background min-h-screen">
      <AppHeader />
      <main className="mx-auto max-w-3xl space-y-6 px-6 py-10">
        <div>
          <h1 className="font-heading text-primary text-3xl font-bold">
            {wikiMe?.name ? `Welcome, ${wikiMe.name}` : "Welcome"}
          </h1>
          <p className="text-muted mt-2">
            BOI Marketing OS gives Claude access to the BOI marketing wiki. You work in Claude; this
            site is where you review proposed changes to pages you own.
          </p>
        </div>

        <Card>
          <CardHeader>
            <CardTitle className="text-lg">Connect Claude</CardTitle>
          </CardHeader>
          <CardContent className="space-y-3 text-sm">
            <p>Add this URL as a custom connector in Claude:</p>
            <code className="border-border bg-background block rounded-md border px-3 py-2 font-mono text-sm break-all select-all">
              {CONNECTOR_URL}
            </code>
            <ol className="text-muted list-decimal space-y-1 pl-5">
              <li>In Claude, open Settings, then Connectors.</li>
              <li>Choose &quot;Add custom connector&quot; and paste the URL above.</li>
              <li>Click Connect and sign in with your BOI Google account.</li>
            </ol>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle className="text-lg">Approvals</CardTitle>
          </CardHeader>
          <CardContent className="space-y-3 text-sm">
            <p className="text-muted">
              When someone proposes a change to a wiki page you own, it appears in Approvals. You
              can read the diff, then approve or reject it.
            </p>
            <Link to="/approvals" className="text-accent font-medium hover:underline">
              {pending > 0
                ? `${pending} ${pending === 1 ? "proposal is" : "proposals are"} waiting for you`
                : "Open Approvals"}
            </Link>
          </CardContent>
        </Card>

        <p className="text-muted text-xs">
          Backend status:{" "}
          <span className={backendStatus === "ok" ? "text-success" : "text-destructive"}>
            {backendStatus}
          </span>
        </p>
      </main>
    </div>
  );
}
